import BlurFade from '../../ui/BlurFade';
import FeaturedProjectCard from './FeaturedProjectCard';
import { projects } from '../../../data/projects';

const FEATURED_IDS = [10, 11, 12];

const FeaturedProjects = () => {
  const featured = projects.filter((p) => FEATURED_IDS.includes(p.id));

  return (
    <section id="featured-projects" className="bg-black py-20 text-white">
      <div className="mx-auto max-w-5xl px-6">
        <BlurFade>
          <h2 className="mb-3 text-2xl font-black sm:text-3xl">
            Featured <span className="text-white/40">Projects</span>
          </h2>
        </BlurFade>
        <BlurFade delay={0.05}>
          <p className="mb-8 text-sm text-white/50">Live products, up and running right now.</p>
        </BlurFade>

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {featured.map((project, i) => (
            <BlurFade key={project.id} delay={i * 0.08}>
              <FeaturedProjectCard project={project} />
            </BlurFade>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturedProjects;
